import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";

export const handleApiError = (error) => {
  if (!error.response) {
    toast.error("Network error. Please check your connection.");
  } else if (error.response.status === 400) {
    toast.error("Invalid data. Please check the form fields.");
  } else if (error.response.status === 409) {
    toast.error("Category already exists. Please choose a different name.");
  } else if (error.response.status === 500) {
    toast.error("Server error. Please try again later.");
  } else {
    toast.error("An unexpected error occurred.");
  }
};

// export const IsPhotosPath = () => {
//   const { pathname, search } = useLocation();
//   return pathname === "/photos" && search === "";
// };
